// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__15tld","inputDescription":"styles_inputDescription__3xrLJ"};